import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { validateToken, getUserEmailToName, translate } from '../../../utils/util';
import { Modal, Button, Row, Col } from 'react-materialize';
import { showMessageToastCustom } from '../../../utils/util';
import ConfigurationService from '../../../services/ConfigurationService';

const TokenListItem = (props) => {
    const onConfirm = (token) => {
        props.tokenDelete(token, response => {
            if (!response) {
                showMessageToastCustom(translate('warning', 'general'), translate('failed-to-delete', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
            }
            else {
                props.history.go(-1)
            }
        })
    }

    return (
        <>
            <span
                className="title sixth-text-color right"
                style={{ position: 'absolute', marginTop: '8px', right: '5px', zIndex: '999' }}
            >
                <Col className="col s12" style={{ padding: 0 }}>
                    <Modal
                        id={`modal-id-${props.data.id}`}
                        fixedFooter
                        style={{ marginTop: "15px", maxHeight: "60%" }}
                        actions={
                            <Row className="center" style={{ height: "60%" }}>
                                <Button className="col s6 btn waves-effect waves-light btn-flat" modal="close">
                                    {translate('cancel', 'general')}
                                </Button>
                                <Button className="col s6 btn waves-effect waves-light btn-flat" onClick={() => onConfirm(props.data)}>
                                    {translate('confirm', 'general')}
                                </Button>
                            </Row>
                        }
                        trigger={
                            <i className="material-icons sixth-text-color" style={{ fontSize: '2rem', cursor: 'pointer' }}>delete</i>
                        }
                    >
                        <Row className="center">
                            <div className="sixth-text-color center">
                                <span className="col s12">
                                    <i className="material-icons large">info_outline</i>
                                </span>
                                <span className="title col s12">{translate("token.confirmation-delete", "configuration")}</span>
                                <span className='col s12' style={{ marginTop: '10px' }}>{props.data.id}</span>
                                <span className='col s12' style={{ marginTop: '10px' }}>{props.data.code}</span>
                                <span className='col s12' style={{ marginTop: '10px' }}>{validateToken(props.data.value)}</span>
                                <span className='col s12' style={{ marginTop: '10px' }}>{getUserEmailToName(props?.usersFromElog, props.data.updateBy)}</span>
                            </div>
                        </Row>
                    </Modal>
                </Col>
            </span>
            <Link
                style={{ display: 'block', padding: '7px' }}
                to={props.route}
                onClick={() => {
                    if (props.onSelectItemChange) {
                        props.onSelectItemChange(props.data);
                    }
                }}
            >
                <span className="secon-text-color" style={{ wordWrap: 'break-word' }}>
                    {`${props.data.code || ''}`}
                </span>
                <span className="truncate second-text-color">
                    <i className="mdi mdi-history" />  {`Valido até: ${validateToken(props.data.value)} `}
                </span>
                <span className="second-text-color">
                    <i className="mdi mdi-account" /> {getUserEmailToName(props?.usersFromElog, props.data.updateBy)}
                </span>
            </Link>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        usersFromElog: state.usersElogReducer.usersElog
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        tokenDelete: (token, callback) => dispatch(ConfigurationService.deleteToken(token.id, callback)),
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(TokenListItem)));

